import {
    AudioLines,
    Cloud,
    Coffee,
    Ellipse,
    FaceSlightlySmiling,
    Feather,
    FlameKindling,
    Flower,
    Heart,
    Leaf,
    Moon,
    Music,
    Sparkles,
    Star,
    Sun,
    type LucideIcon,
} from 'lucide-react';

/**
 * The icons a voice can have. Keep the keys the same as VOICE_ICONS in the app
 * (obsessless-app/src/pages/settings/components/SettingsVoiceCards.tsx). An app that does
 * not know a key shows its fallback icon.
 */
export const VOICE_ICONS: Record<string, LucideIcon> = {
    'audio-lines': AudioLines,
    ellipse: Ellipse,
    'flame-kindling': FlameKindling,
    'face-slightly-smiling': FaceSlightlySmiling,
    sparkles: Sparkles,
    heart: Heart,
    sun: Sun,
    moon: Moon,
    leaf: Leaf,
    feather: Feather,
    coffee: Coffee,
    cloud: Cloud,
    flower: Flower,
    music: Music,
    star: Star,
};
